export enum adminRecruitmentListTypes {
    FETCH_ADMIN_RECRUITMENT_LIST_REQUEST = "FETCH_ADMIN_RECRUITMENT_LIST_REQUEST",
    FETCH_ADMIN_RECRUITMENT_LIST_SUCCESS = "FETCH_ADMIN_RECRUITMENT_LIST_SUCCESS",
    FETCH_ADMIN_RECRUITMENT_LIST_FAILURE = "FETCH_ADMIN_RECRUITMENT_LIST_FAILURE",
  }